import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormControl,Label, FormGroup, ButtonToolbar, Button,ButtonGroup, InputGroup, Row, Col } from 'react-bootstrap'
import Select from 'react-select';
import { Checkbox } from 'react-icheck';
import Moment, { defaultFormat } from 'moment';
import FontAwesome from 'react-fontawesome';
import WorkdocStore from '../../stores/WorkdocStore'
import CashflowStore from '../../stores/CashflowStore'
import IncentivePayeePageModal from './IncentivePayeePageModal'
import IframeModal from '../../component/element/IframeModal'
import $ from 'jquery'
import withSizes from 'react-sizes';
import ReportMobileTable from '../report/ReportMobileTable'

var NotificationSystem = require('react-notification-system');
const api = require('api')
const messages = api.getMessage().view.cashflow.IncentiveExpenseRecord
const DEFAULT_ROW = 1
class IncentiveExpenseRecord extends Component {
  constructor(props) {
    super(props)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const curMonth = parseInt(Moment().format('MM'))
    const curDay = parseInt(Moment().format('DD'))
    const all_day = Moment().daysInMonth()

    const optionsDay = []
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }
    
    for (var i=1;i<=all_day;i++) {
      
      optionsDay.push({
        value: i,
        label: i
      })
    }
    
    const optionsMonth = [
      { value: 1, label: messages['January'] },
      { value: 2, label: messages['February'] },
      { value: 3, label: messages['March'] },
      { value: 4, label: messages['April'] },
      { value: 5, label: messages['May'] },
      { value: 6, label: messages['June'] },
      { value: 7, label: messages['July'] },
      { value: 8, label: messages['August'] },
      { value: 9, label: messages['September'] },
      { value: 10, label: messages['October'] },
      { value: 11, label: messages['November'] },
      { value: 12, label: messages['December'] }
    ];

    this.state = {
      loading:false,
      showSave:true,
      showPayee:false,
      checked:{},
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      optionsDay: optionsDay,
      defaultYear: yTh,
      defaultMonth: curMonth,
      defaultDay: curDay,
      data: [],
      deletedData:[],
      payeeList:[],      
      payeeValue:'',
      work_no_list:[],
      showCar:false,
      car_index:0,
      styleCarRegis:[],
      filter:{park:true,no_park:true,paid_yet:true,no_paid_yet:true},
      showIncentivePayee:false,
      query:'',
      isSearchQuery:null
    }

    this.pcInput = new Array(DEFAULT_ROW).fill('')
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;

    $('body').on('click', ()=> { 
      if ($('.Select').hasClass('is-open')) {
        $('.table-responsive').css( "overflow-x", "initial" );
        $('.table-responsive').css( "overflow-y", "unset" );
      } else {
        $('.table-responsive').css( "overflow-x", "auto" );
        $('.table-responsive').css( "overflow-y", "" );
      }  
    });

    this.loadCashflowIncentiveExpenseRecord(this.state.defaultYear,this.state.defaultMonth,'all')
    this.loadRecordIncentiveExpensePayee()
  }

  componentWillReceiveProps(newProps){

  }

  getOptionsDay(year,month){
    let optionsDay = []
    const all_day = Moment(year+'-'+month,'YYYY-MM').daysInMonth()
    for (var i=0;i<=all_day;i++) {
      if (i>0) {
        optionsDay.push({
          value: i,
          label: i
        })
      }
    }
    return optionsDay
  }

  searchWork(index,work_no){
    let {data} = this.state
    // console.log('data',index,work_no,data)
    WorkdocStore.loadWorkdocAutocompleteWorkNo(work_no,(result)=>{
      if(result.data.length===1 && result.data[0].work_no===work_no){
        data[index].work_no = result.data[0].work_no
        data[index].car_registration_no = result.data[0].car_registration_no
        data[index].car_info = result.data[0].car_info
        data[index].insurer_name = result.data[0].insurer_name
        data[index].park_status = result.data[0].park_status
        this.setState({data:data})
      }else{
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Notification number not found']+' '+work_no+ ' '+messages['Please Try Again'],
          level: 'error',
          position: 'tc'
        })
      }    
    })
  }

  loadRecordIncentiveExpensePayee() {
    let {payeeList} = this.state
    
    CashflowStore.loadRecordIncentiveExpensePayee((result)=> {
      
      result.data.forEach(function(item,index) {
        payeeList.push({
          label:item.Name,
          value:item.Value,
          item : item
        })
        
      })
      this.setState({payeeList:payeeList})
    })
  }

  loadCashflowIncentiveExpenseRecord(defaultYear='',defaultMonth='',payeeValue='',filterP=null) {
    
    let {query,styleCarRegis,checked,filter,isSearchQuery} = this.state

    // if(payeeValue==''){
    //   return;
    // }

    if(filterP!==null)
      filter = filterP
    let params = {year:defaultYear-543,month:defaultMonth,category:(isSearchQuery==='car_registration_no'?isSearchQuery:this.props.incentiveType),payee_id:payeeValue,q:query}
    params = Object.assign(params,filter)
    this.setState({loading:true})
    CashflowStore.loadCashflowIncentiveExpenseRecord(params,(result)=> {
      let data = result.data.reduce(function(rresult,item,index) {
        let pass = false
        if(item.park_status==='park' && filter.park){
          pass = true
        }
        if(item.park_status==='no_park' && filter.no_park){
          pass = true
        }

        if(pass)
          rresult.push(item)
        checked[item.ie_record_id] = (item.paid_yet*1===1)
        return rresult
      },[])
      this.setState({loading:false,data:data,styleCarRegis:styleCarRegis,isSearchQuery:null})
    })
  }

  newEmptyRow(number=1) {
    let {payeeValue} = this.state
    return new Array(number).fill(null).map((item,index)=>{      
      return {work_no:'',park_status:'',car_registration_no:'',car_info:'',insurer_name:'',payment_date:'',paid_yet:0,paid_to:'',payee_id:payeeValue,category:this.props.incentiveType,ie_record_id:'',amount:''}
    })
  }

  // getOptionsDay(optionsDay){
  //   return [{label:'ทั้งเดือน',value:0}].concat(optionsDay)
  // }

  onYearChange(e) {
    let {defaultYear,defaultMonth,payeeValue,optionsDay} = this.state
    defaultYear = e.value
    optionsDay = this.getOptionsDay(defaultYear-543,defaultMonth)
    this.setState({defaultYear:e.value,optionsDay:optionsDay})
    this.loadCashflowIncentiveExpenseRecord(e.value,defaultMonth,payeeValue)
  }

  onMonthChange(e) {
    let {defaultYear,defaultMonth,payeeValue,optionsDay} = this.state
    defaultMonth = e.value
    optionsDay = this.getOptionsDay(defaultYear,defaultMonth)    
    this.setState({defaultMonth:e.value,optionsDay:optionsDay})
    this.loadCashflowIncentiveExpenseRecord(defaultYear,defaultMonth,payeeValue)
  }

  onDayChange(index,e) {
    let {defaultYear,defaultMonth,data} = this.state
    
    data[index].payment_date =  (defaultYear-543)+'-'+defaultMonth+'-'+e.value
    data[index].usage_date =  (defaultYear-543)+'-'+defaultMonth+'-'+e.value
    this.setState({data:data})
  }

  onSearchSelect(e){
    let {payeeValue,defaultYear,defaultMonth,defaultDay} = this.state
    payeeValue = e.value
    this.setState({payeeValue:payeeValue})
    this.loadCashflowIncentiveExpenseRecord(defaultYear,defaultMonth,payeeValue)
  }

  onQueryChange(e) {
    this.setState({query:e.target.value})
  }

  onQueryClick() {
    let {payeeValue,defaultYear,defaultMonth} = this.state
    this.setState({isSearchQuery:'car_registration_no'},()=>{
      this.loadCashflowIncentiveExpenseRecord(defaultYear,defaultMonth,payeeValue)
    })
  }

  onQueryKeyPress(e) {
    if (e.charCode===13) {
      e.preventDefault()
      this.onQueryClick()
    }
  }

  onTextChange(index,key,e) {
    let {data,styleCarRegis,car} = this.state
    if (key==='car_registration_no') {
      data[index][key] = e.target.value
      this.setState({data:data})
      this.loadCarRegistrationNo(index)
      if (data[index][key]==='') {
        styleCarRegis[index] = ''
        data[index]['work_no'] = ''
        this.setState({styleCarRegis:styleCarRegis})
      }  
    } else if (key==='payee_id') { 
      data[index][key] = e.value
      this.setState({data:data})
    } else {
      data[index][key] = e.target.value
      this.setState({data:data})
    }  
  }

  onKeyPress(index,e){
    let {data} = this.state
    if (e.charCode == 13) {
      this.searchWork(index,data[index].work_no)
    }
  }

  onTextSelect(index,key,e,eitem) {
    let {data} = this.state

    if (key=='work_no') {
      data[index]['car_registration_no'] = eitem.id
      data[index]['work_no'] = eitem.work_no
      this.setState({data:data})
    }else if (key=='car_registration_no') {
      data[index]['car_registration_no'] = eitem.id
      data[index]['work_no'] = eitem.work_no
      this.setState({data:data})
    } else {
      data[index]['category'] = e
      this.setState({data:data})
    }  
  }

  onDeleteClick(index){
    let {data,deletedData,styleCarRegis} = this.state
    let item = data.splice(index,1)
    if(item[0].cashflow_record_id!==''){
      deletedData.push(item[0])
    }
    styleCarRegis[index] = ''
    this.setState({data:data,deletedData:deletedData,styleCarRegis:styleCarRegis})
  }

  onPaymentCheck(item,index){
    let {checked} = this.state

    if(checked[item.ie_record_id]===undefined){
      checked[item.ie_record_id] = true
    }else{
      checked[item.ie_record_id] = !checked[item.ie_record_id] 
    }

    this.setState({checked:checked})
  }

  getUsageDay(usageDate){
    if(usageDate==='')
      return ''
    let uM = Moment(usageDate,'YYYY-MM-DD')

    return uM.format('DD')*1
  }

  

  renderRowData() {
    let {data} = this.state
    if (data===undefined||data.length===0) {
      return(<tr><td colSpan={11}>{messages['No data']}</td></tr>)
    } else { 
      return(
        data.map((item,index) => {
          let uDay = this.getUsageDay(item.payment_date)
          return (
            <tr key={index} className=''>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>
                    <Checkbox
                      onChange={this.onPaymentCheck.bind(this, item, index)}
                      checked={this.state.checked[item.ie_record_id]}
                      checkboxClass="icheckbox_square-blue"
                      increaseArea="20%"
                      label=""
                    />
              </td>
              <td>
                <Select                  
                  clearable={false}                                 
                  name="form-field-name"
                  placeholder='...'
                  value={uDay}
                  options={this.state.optionsDay}
                  onChange={this.onDayChange.bind(this,index)}
                />
              </td>          
              <td className='text-center'>
                {item.park_status==='park'?(<Label bsStyle='success'>{messages['Park']}</Label>):item.park_status==='no_park'?(<Label bsStyle='pink'>{messages['No parking']}</Label>):(<Label bsStyle='default'>{messages['Not specified']}</Label>)}
              </td>   
              <td className='text-left'>
                <Select
                  clearable={false}
                  value={item.payee_id}
                  options={this.state.payeeList}
                  placeholder={messages['Select employee']+'...'}
                  onChange={this.onTextChange.bind(this,index,'payee_id')}
                />
              </td>
              <td className='text-center'>
               <FormControl 
                  value={item.work_no}                      
                  onChange={this.onTextChange.bind(this,index,'work_no')}
                  onKeyPress={this.onKeyPress.bind(this,index)}
                />
              </td>
              <td className='text-center'>
                <FormControl 
                  value={item.car_registration_no} 
                  readOnly 
                />
              </td>
              <td className='text-center'>
                <FormControl 
                  value={item.car_info} 
                  readOnly 
                />
              </td>
              <td className='text-center'>
                <FormControl 
                  value={item.insurer_name} 
                  readOnly 
                />
              </td>
              <td className='text-right'>
                <FormControl 
                  className='text-right'
                  value={item.amount}                      
                  onChange={this.onTextChange.bind(this,index,'amount')}
                />
              </td>                          
              <td className='text-center'>
                <Button bsStyle='link'  className='text-red' onClick={this.onDeleteClick.bind(this,index)}><FontAwesome name='trash' /></Button>
              </td>
            </tr>
          )
        })  
      )    
    }      
  }

  onRowAdd(number){
    let {data} = this.state
    data = data.concat(this.newEmptyRow(number))
    
    this.pcInput = new Array(data.length).fill('')
    this.setState({data:data})
  }

  onFilterClick(key){
    let {filter,payeeValue} = this.state

    filter[key] = !filter[key]

    this.setState({filter:filter})

    this.loadCashflowIncentiveExpenseRecord(this.state.defaultYear,this.state.defaultMonth,payeeValue,filter)
  }

  renderNewItemButton(){
    let {is_search} = this.state
    if(is_search){
      return (<div/>)
    }else
    return (
      <Row style={{marginTop:'10px'}} className='row-new-item-button'>
        <Col md={12}>
          <ButtonToolbar>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;{messages['Add item']}</Button>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;{messages['Add 10 item']}</Button>
          </ButtonToolbar>     
        </Col>  
      </Row>
    )
  }

  onNewPayee(payee){
    let {payeeList} = this.state

    payeeList.push({label:payee.first_name+' '+payee.last_name,id:payee.ie_payee_id,item:payee})
    this.setState({payeeList:payeeList})
  }

  onSaveClick(e){
    let that = this
    let {data,deletedData,checked,defaultYear,defaultMonth,defaultDay,styleCarRegis} = this.state

    data = data.map((item,index)=>{
      if(checked[item.ie_record_id]!==undefined && checked[item.ie_record_id]){
        item.paid_yet = "1"
      }else{
        item.paid_yet = "0"
      }
      return item
    })

    let postData = {itemlist:data,deleted_item:deletedData}
    this.setState({loading:true})
    

    CashflowStore.saveCashflowIncentiveExpenseRecord(postData,function(result) {
      if(result.status ==='OK') {
        that.refs.notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Save successfully'],
          level: 'info',
          position: 'tc',        
        });
        that.setState({deletedData:[]})
        that.setState({loading:false,data:result.data})
      }else{  
        that.setState({loading:false})
      }
    },function(){
      that.setState({loading:false})
    })
  }

  onIncentivePayeeClick() {
    this.setState({showIncentivePayee:true})
  }

  onIncentivePayeeHide() {
    this.setState({showIncentivePayee:false})
  }

  onPrintClick() {
    let {defaultYear,defaultMonth,payeeValue,filter} = this.state
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportTJYIncentiveExpenseInsurance&year='+(defaultYear-543)+'&month='+defaultMonth+'&payee_value='+payeeValue+'&incentive_type='+this.props.incentiveType+'&park='+filter.park+'&no_park='+filter.no_park+'&paid_yet='+filter.paid_yet+'&no_paid_yet='+filter.no_paid_yet
    } else{
      url = './pdf/v2/?startPage=PrintReportTJYIncentiveExpenseInsurance&year='+(defaultYear-543)+'&month='+defaultMonth+'&payee_value='+payeeValue+'&incentive_type='+this.props.incentiveType+'&park='+filter.park+'&no_park='+filter.no_park+'&paid_yet='+filter.paid_yet+'&no_paid_yet='+filter.no_paid_yet
    }
    this.refs.iframe.loadUrl(url)
  }

  renderTable() {
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid table-tool' style={{marginBottom:'0',minWidth:'1480px'}}>
          <thead>
            <tr>
              <th className='text-center' style={{ width: '20px' }}>{messages['Number']}</th>
              <th className='text-center' style={{ width: '20px' }}>{messages['Pay']} ?</th>
              <th className='text-center' style={{ width: '65px' }}>{messages['Pay date']}</th>
              <th className='text-center' style={{ width: '65px' }}>{messages['Park']} ?</th>         
              <th className='text-center' style={{ width: '120px' }}>{messages['Claim employee']}</th>    
              <th className='text-center' style={{ width: '100px' }}>{messages['Notification number']}</th>
              <th className='text-center' style={{ width: '100px' }}>{messages['Car registration no']}</th>
              <th className='text-center' style={{ width: '150px' }}>{messages['Brand']}</th>            
              <th className='text-center' style={{ width: '250px' }}>{messages['Insurance']}</th>
              <th className='text-center' style={{ width: '60px' }}>{messages['Cost']}</th>            
              <th className='text-center' style={{ width: '20px' }}>{messages['Delete']} ?</th>
            </tr>  
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
          <tr>
              <th className='text-center' colSpan={9}></th>           
              <th className='text-right' >{this.getMoneySpent().toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-center' colSpan={1}></th>
            </tr>  
          </tfoot>
        </table>
      </div>  
    )
  }

  getMoneySpent() {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      sum = parseFloat(sum) + parseFloat(item.amount)
    })
    if (isNaN(sum)){
      sum = 0
    }
    return sum
  }

  renderStatus(item,items) {
    let payStatus = (<div />)
    let {checked} = this.state
    if (checked[items.ie_record_id])
      payStatus = (<Label bsStyle='success'>{messages['Paid']}</Label>)
    else 
      payStatus = (<Label bsStyle='warning'>{messages['Not paid yet']}</Label>)

    if (items.park_status=='park') {
      return(<span><Label bsStyle='success'>{messages['Park']}</Label>&nbsp;{payStatus}</span>)
    } else if (items.park_status=='no_park') {
      return(<span><Label bsStyle='pink'>{messages['No parking']}</Label>&nbsp;{payStatus}</span>)
    } else {
      return(<span><Label bsStyle='default'>{messages['Not specified']}</Label>&nbsp;{payStatus}</span>)
    }
  }           

  renderMobileTable(){
    let {data} = this.state
    let fieldMap = {title:'insurer_name',amount:'amount',sub_title:'car_registration_no',date:'payment_date',status:'park_status',sub_status:''}
    return(
      <div>
        <ReportMobileTable
          itemlist={data}
          fieldMap={fieldMap}
          keyIndex={'ie_record_id'}
          renderWorkStatus={this.renderStatus.bind(this)}
        />
      </div>
    )
  }

  render() {
    let {loading,payeeList,payeeValue,filter} = this.state
    let {isMobile} = this.props
    var style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          margin: '10px 5px 2px 1px',
          fontSize:'30px',
          width:'400px',
          textAlign:'center'
        },
      }
    }

    return (
      <div className='incentive-expense-record'>
        <Box loading={loading}>
          <Box.Header border={true}>
            <Box.Title>{messages['Claim compensation']}</Box.Title>
            <Box.Tools>
              <Button className='bg-maroon'
                onClick={this.onPrintClick.bind(this)}
              >
                <FontAwesome name='print' /><span className='icon-text'>&nbsp;{messages['Print document']}</span>
              </Button>
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            <Form inline style={{marginBottom:'5px'}}>
              <FormGroup style={{display:'inline-flex'}}>
                <Select
                  clearable={false}
                  name="form-field-name"                
                  value={ this.state.defaultYear }
                  options={this.state.optionsYear}
                  style={{ width: "80px" }}
                  onChange={ this.onYearChange.bind(this) }
                />
              </FormGroup>  
              {' '}
              <FormGroup style={{display:'inline-flex'}}>
                <Select
                  clearable={false}
                  name="form-field-name"
                  value={ this.state.defaultMonth }
                  options={this.state.optionsMonth}
                  style={{ width: "120px" }}
                  onChange={ this.onMonthChange.bind(this) }
                />
              </FormGroup>              
              {' '}
              <FormGroup style={{display:'inline-flex'}}>
                <Select
                  clearable={false}
                  name="form-field-name"
                  value={payeeValue}
                  options={payeeList}
                  style={{ width: "250px" }}
                  placeholder={messages['Select employee']+'...'}
                  onChange={this.onSearchSelect.bind(this)}
                />
                <Button onClick={()=>this.setState({showIncentivePayee:true})}><FontAwesome name='plus' /></Button>
              </FormGroup> 
              {' '}
              <FormGroup>
                <InputGroup>
                  <FormControl value={this.state.query} placeholder={messages['Search registration number']+'...'} onChange={this.onQueryChange.bind(this)} onKeyPress={this.onQueryKeyPress.bind(this)} />
                  <InputGroup.Addon className="btn" onClick={this.onQueryClick.bind(this)}>
                    <FontAwesome name='search' />
                  </InputGroup.Addon>
                </InputGroup>
              </FormGroup>
              {' '}
              <div style={{marginLeft:'15px',display:(payeeValue==='')?'none':'inline-block'}}> 
                <ButtonGroup>
                  <Button bsStyle={filter.park?'success':'default'} onClick={this.onFilterClick.bind(this,'park')}>{messages['Park']}</Button>
                  <Button bsStyle={filter.no_park?'pink':'default'} onClick={this.onFilterClick.bind(this,'no_park')}>{messages['No parking']}</Button>
                </ButtonGroup>
                <ButtonGroup style={{marginLeft:'15px'}}>
                  <Button bsStyle={filter.paid_yet?'success':'default'} onClick={this.onFilterClick.bind(this,'paid_yet')}>{messages['Paid']}</Button>
                  <Button bsStyle={filter.no_paid_yet?'warning':'default'} onClick={this.onFilterClick.bind(this,'no_paid_yet')}>{messages['Not paid yet']}</Button>                
                </ButtonGroup>  
              </div>        
            </Form>
            {isMobile?this.renderMobileTable():this.renderTable()}
            {this.renderNewItemButton()}
          </Box.Body>
          <Box.Footer>
            <ButtonToolbar className='pull-right' >            
              <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save']}</Button>
            </ButtonToolbar>
          </Box.Footer>        
          <NotificationSystem ref="notificationSystem" style={style} />    
        </Box>
        <IncentivePayeePageModal 
          show={this.state.showIncentivePayee}
          onHide={this.onIncentivePayeeHide.bind(this)}
        />
        <IframeModal ref='iframe' title={messages['Print document']} />
      </div>
    )
  }
}

IncentiveExpenseRecord.defaultProps = {  
  incentiveType:'insurance',
  show:false
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default IncentiveExpenseRecord = withSizes(mapSizesToProps)(IncentiveExpenseRecord);


// WEBPACK FOOTER //
// ./src/view/cashflow/IncentiveExpenseRecord.js